module.exports = __webpack_public_path__ + "img/survey-text.710dff03.png";